import React, { useRef } from "react";
import './App.css';
import Navbar from './Components/Navbar';
import ProfileDetail from './Components/ProfileDetail';
import Resume from './Components/Resume';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Footer from './Components/Footer';

function App() {

  const ProfileDetailRef = useRef(null);
  const ResumeRef = useRef(null);
  const ProjectsRef = useRef(null);
  const ContactRef = useRef(null);


  return (
    <div className="App">
      <div className='App-header'>
        <Navbar
          ProfileDetailRef = {() => ProfileDetailRef.current?.scrollIntoView({ behavior: "smooth" })}
          ResumeRef = {() => ResumeRef.current?.scrollIntoView({ behavior: "smooth" })}
          ProjectsRef = {() => ProjectsRef.current?.scrollIntoView({ behavior: "smooth" })}
          ContactRef = {() => ContactRef.current?.scrollIntoView({ behavior: "smooth" })}
        />
        <div  style={{ width: "100%" }} ref={ProfileDetailRef}><ProfileDetail 
        scrollToProjects =  {() => ProjectsRef.current?.scrollIntoView({ behavior: "smooth" })}
        scrollToContact = {() => ContactRef.current?.scrollIntoView({ behavior: "smooth" })} /></div>
        <div  style={{ width: "100%" }} ref={ResumeRef}><Resume /></div>
        <div  style={{ width: "100%" }} ref={ProjectsRef}><Projects /></div>
        <div  style={{ width: "100%" }} ref={ContactRef}><Contact /></div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
